import { Store, Zap, ShieldCheck, Truck, Apple, Play, MapPin, Smartphone } from "lucide-react";
import { Link } from "react-router-dom";
import { APP_FEATURES } from "@/constants/testIds";
import { useContent } from "@/context/ContentContext";

const ICONS = { Store, Truck, Zap, ShieldCheck, MapPin, Smartphone };

export const AppFeatures = () => {
  const { content } = useContent();
  const list = content.appFeatures || [];
  const FEATURES = list.map((f, i) => ({
    ...f,
    Icon: ICONS[f.icon] || Store,
    color: i % 2 === 0 ? "#0E7A3B" : "#F5A800",
  }));
  return (
    <section id="app" data-testid={APP_FEATURES.root} className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
          <div className="lg:col-span-8">
            <p className="font-utility text-xs uppercase tracking-[0.25em] text-[#0E7A3B]">
              L'application
            </p>
            <h2 className="mt-4 font-display text-4xl md:text-6xl text-[#16241B] leading-[1.02] tracking-tighter">
              Pensée pour votre ville,
              <br />
              <span className="text-[#0E7A3B]">taillée pour vos usages.</span>
            </h2>
          </div>
          <div className="lg:col-span-4">
            <p className="text-[#16241B]/70 text-base leading-relaxed">
              Zafara concentre les usages du quotidien dans une seule
              application, au service des commerces, vendeurs et livreurs
              indépendants du Bénin.
            </p>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {FEATURES.map((f, i) => (
            <div
              key={f.title}
              className={`group relative overflow-hidden rounded-3xl p-8 md:p-10 border transition-all duration-500 hover:-translate-y-1 ${
                i % 2 === 0
                  ? "bg-white border-[#EDE7D9] hover:shadow-[0_20px_50px_rgba(14,122,59,0.08)]"
                  : "bg-[#16241B] border-[#16241B] text-white hover:shadow-[0_20px_50px_rgba(22,36,27,0.35)]"
              }`}
            >
              <div
                className="inline-flex h-12 w-12 items-center justify-center rounded-2xl"
                style={{
                  background: i % 2 === 0 ? "#FBFAF6" : "rgba(255,255,255,0.08)",
                  border: i % 2 === 0 ? "1px solid #EDE7D9" : "1px solid rgba(255,255,255,0.15)",
                }}
              >
                <f.Icon className="h-6 w-6" style={{ color: f.color }} />
              </div>
              <h3
                className={`mt-8 font-display text-2xl md:text-3xl leading-tight tracking-tight ${
                  i % 2 === 0 ? "text-[#16241B]" : "text-white"
                }`}
              >
                {f.title}
              </h3>
              <p
                className={`mt-4 text-base leading-relaxed ${
                  i % 2 === 0 ? "text-[#16241B]/70" : "text-white/75"
                }`}
              >
                {f.text}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-14 rounded-3xl bg-[#F5A800] p-8 md:p-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 shadow-[0_20px_60px_rgba(245,168,0,0.25)]">
          <div>
            <p className="font-utility text-xs uppercase tracking-[0.25em] text-[#16241B]/70">
              Prêt à essayer ?
            </p>
            <p className="mt-2 font-display text-2xl md:text-3xl text-[#16241B] leading-tight tracking-tight max-w-xl">
              Téléchargez Zafara maintenant. C'est gratuit et ça change tout.
            </p>
          </div>
          <div className="flex gap-3">
            <a
              href={content.stores.appStore}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-full bg-[#16241B] text-white px-5 py-3 text-sm font-semibold hover:bg-[#0E7A3B] transition-colors"
            >
              <Apple className="h-4 w-4" /> App Store
            </a>
            <Link
              to="/telecharger"
              className="inline-flex items-center gap-2 rounded-full bg-[#0E7A3B] text-white px-5 py-3 text-sm font-semibold hover:bg-[#16241B] transition-colors"
            >
              <Play className="h-4 w-4 fill-white" /> Google Play
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
